export default __webpack_public_path__ + "static/media/mp3.100f384c.svg";